import { render, staticRenderFns } from "./SignInButtonComponent.vue?vue&type=template&id=6f87c576&scoped=true"
import script from "./SignInButtonComponent.vue?vue&type=script&lang=js"
export * from "./SignInButtonComponent.vue?vue&type=script&lang=js"
import style0 from "./SignInButtonComponent.vue?vue&type=style&index=0&id=6f87c576&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f87c576",
  null
  
)

export default component.exports